import { DESKTOP_HARDCODE_LINKS } from 'constants/links';

import isMobile from './isMobile';

export const getQrCodeLink = () => {
    return isMobile.android() ? DESKTOP_HARDCODE_LINKS.GOOGLE : DESKTOP_HARDCODE_LINKS.APPLE;
};
